<template>
    <!--a  href="img/document/Rechnung_1073743051_2021.pdf" target="_blank"> Rechnung </a-->

   <div class="container-fluid g-2 web5__rowcard">
     <div class="row">
       <div class="col">
        <div class="card">
          <h5 class="card-header">Monitoring</h5>
          <div class="card-body">
            <h5 class="card-title">Geräte Übersichten und Wartung</h5>
            <p class="card-text">Hier erhalten Sie übersichten über Ihre Geräte.</p>
            <router-link :to="{ name: 'ControlCenter'}">Zum Monitoring</router-link>
          </div>
        </div>
       </div>
       <div class="col">
        <div class="card">
          <h5 class="card-header">Dokumentenverwaltung</h5>
          <div class="card-body">
            <h5 class="card-title">Gebäudepläne</h5>
            <p class="card-text">Überprüfen der aktuellen Gebäudepläne</p>
            <router-link :to="{ name: 'DocumentManagement'}">Anzeigen</router-link>
          </div>
        </div>
       </div>
     </div>
     <div class="row pt-4">
       <div class="col">
        <div class="card">
          <h5 class="card-header">Kundendienst</h5>
          <div class="card-body">
            <h5 class="card-title">Störungsmanagement</h5>
            <p class="card-text">Störungen erfassen und Rücksendeschein erzeugen</p>
            <router-link :to="{ name: 'RecordMalfunction'}">Melden Sie hier Ihre Störung</router-link>
          </div>
        </div>
       </div>
       <div class="col">
        <div class="card">
          <h5 class="card-header">Rechnungsinfo</h5>
          <div class="card-body">
            <h5 class="card-title">Rechnungsinfo anzeigen</h5>
            <p class="card-text">SOS24Aid-Stammdatenblatt</p>
            <router-link :to="{ name: 'ShowDeviceData'}">Erstellen</router-link>
          </div>
        </div>
       </div>
     </div>
  </div>
</template>

<script language="ts">
import {  ref } from "vue";
import { apiPost } from "@/services/api/fetchapi";
import { useStore } from "vuex";


export default {

  name: "HomeContent",
  inheritAttrs: false,
  components: {},
  setup() {
    const store = new useStore();
    const isReportAllowed = ref(false);
    async function isReportRole() {
      const response = await apiPost("ComponentView/isBerichtRoleAllowed", {
        userId: store.getters["userstore/getUser"],
      });
      isReportAllowed.value = response.success;
    }

    isReportRole();

    return {
      isReportAllowed,
    }
  },
}
</script>
<style scoped language="scss">
  .web5__rowcard {
    max-width: 80% !important;
    margin-top: 10%;
    margin-bottom: 10%;
  }

</style>